export default __webpack_public_path__ + "static/media/V - STRAP.8cffdaf9.jpg";